import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { get } from "lodash";
import Checkbox from "@material-ui/core/Checkbox";
import Cookie from "js-cookie";
import { Button } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";

export default function AgeGate(props) {
  const dispatch = useDispatch();

  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [verified, setVerified] = useState(false);

  const pageLoading = useSelector((state) =>
    get(state, "prismic.age_gate.loading", true),
  );
  const page = useSelector((state) =>
    get(state, "prismic.age_gate.data", false),
  );

  const logo = get(page, "age_gate[0].logo.url");
  const backgroundColor = get(page, "age_gate[0].background_color");
  const textColor = get(page, "age_gate[0].text_color");
  const overlayColor = get(page, "age_gate[0].overlay[0].text");

  const copy = {
    english: {
      headline: "Are You Over 21?",
      body: (
        <>
          Yes, I am at least twenty-one (21) years of age or am otherwise a
          qualified patient. By clicking “I agree” and entering the website, I
          agree to be bound by the{" "}
          <Link to="/terms-of-service">Terms of Service</Link> and{" "}
          <Link to="/privacy-policy">Privacy Policy</Link>.
        </>
      ),
      checkbox: "I Agree",
      button: "Enter Site",
    },
  };

  const localizedCopy = copy.english;

  useEffect(() => {
    dispatch({
      type: "PRISMIC_LOAD_SINGLE_PAGE",
      key: "age_gate",
    });
  }, [dispatch]);

  const handleCheckbox = (e) => {
    setCheckboxChecked(!checkboxChecked);
  };

  const allowPassage = (event) => {
    event.preventDefault();
    if (checkboxChecked) {
      Cookie.set("sunnyside_wellness_over21", true, { expires: 3 });
      setVerified(true);
      props.verifyAge();
    } else {
      return;
    }
  };

  const textColorStyle = {
    color: textColor,
  };

  const backgroundColorStyle = {
    background: backgroundColor,
  };

  return (
    !pageLoading &&
    !verified && (
      <div id="age-gate" style={backgroundColorStyle}>
        {overlayColor && <div className="overlay"></div>}

        <div className="age-gate-content">
          <div className="logo">
            {logo && <img alt="Good News Logo" src={logo} />}
          </div>
          <div className="content-section" style={textColorStyle}>
            <h2>{localizedCopy.headline}</h2>
            <p>{localizedCopy.body}</p>
            <form id="age-gate-form" onSubmit={allowPassage}>
              <FormControlLabel
                value="start"
                className="mb-20"
                control={
                  <Checkbox
                    className="age-gate-checkbox"
                    checked={checkboxChecked}
                    onChange={handleCheckbox}
                    color="primary"
                    inputProps={{ "aria-label": localizedCopy.checkbox }}
                  />
                }
                label={
                  <span className="age-gate-checkbox-copy">
                    {localizedCopy.checkbox}
                  </span>
                }
                labelPlacement="end"
              />

              <br></br>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disableElevation
                disabled={!checkboxChecked}
                className="age-gate-enter-button"
                style={{ marginTop: "10px" }}
              >
                {localizedCopy.button}
              </Button>
            </form>
          </div>
        </div>
      </div>
    )
  );
}
